import { ActionTypes } from '..';

export const changeWindowDimensionAXN = (dimension: { width: number; height: number }) => {
  return {
    type: ActionTypes.CHANGE_WINDOW_DIMENSION_ON_RESIZE,
    payload: dimension,
  };
};
